<template>
  <div>
    <hit_delete style="color: red !important;" :icon="true" :callback="function(){ remove_board() }">{{ $t("message.allDataWillBeDeleted") }}</hit_delete>
  </div>
</template>

<script>

export default{
  props: { edit: Object, callback: Function},
  data () {
    return {

    }
  },
  methods: {
    remove_board () {
      this.$store.dispatch('set_remove_board', this.edit.row)
      this.callback()
    }
  }
}
</script>
